function feeId(fee) {
  const raw = typeof fee === 'object' ? fee?.id : fee
  const id = Number(raw)
  if (!Number.isFinite(id) || id <= 0) return null
  return id
}

export function customFeeIdsFromPackage(eventPackage) {
  const fees = Array.isArray(eventPackage?.customFees)
    ? eventPackage.customFees
    : eventPackage?.customFee?.id
      ? [eventPackage.customFee]
      : []
  const ids = []
  const seen = new Set()
  for (const fee of fees) {
    const id = feeId(fee)
    if (id == null || seen.has(id)) continue
    seen.add(id)
    ids.push(id)
  }
  return ids
}

export function assignmentCustomFeeSeedIds({
  eventPackage,
  sourceOrderCustomFeeIds,
  sourceOrderId,
  addSeatsToOrderId,
  addCustomFeeToOrderId,
  isFlexPackAssignment,
  isAccessPassAssignment,
}) {
  if (
    Array.isArray(sourceOrderCustomFeeIds) &&
    sourceOrderCustomFeeIds.length
  ) {
    return sourceOrderCustomFeeIds
  }

  const isNewSeasonPackageAssignment =
    eventPackage &&
    !isFlexPackAssignment &&
    !isAccessPassAssignment &&
    !sourceOrderId &&
    !addSeatsToOrderId &&
    !addCustomFeeToOrderId

  if (!isNewSeasonPackageAssignment) return []
  return customFeeIdsFromPackage(eventPackage)
}
